import { action } from 'typesafe-actions';

import { ActionTypes } from './types';

export const setDirty = (value: boolean) => action(ActionTypes.SET_DIRTY, { value });
export const openDialog = (issuer: string, title?: string, content?: string) => action(ActionTypes.OPEN_DIALOG, { issuer, title, content });
export const clearDialog = () => action(ActionTypes.CLEAR_DIALOG);
export const confirmClicked = () => action(ActionTypes.CONFIRM_CLICKED);
export const cancelClicked = () => action(ActionTypes.CANCEL_CLICKED);